/* Kaching bundles → horizontal scroller (mobile) — native port of the winning IG A/B variant.
 * Adds nav arrows + dots + touch scroll to the Kaching "kaching-bundles__bars" row.
 * Default-quantity selection is handled by the Kaching app settings, so it is NOT done here.
 *
 * Mixed-product bundle bars (e.g. "Startsæt") are too tall for the scroller, so they get a full-width
 * row under the dots instead. Kaching owns (and re-renders) its bars, so the bar is not moved: the
 * original stays hidden in the scroller, a synced copy is shown in the row, and taps on the copy are
 * passed to the original so Kaching still handles selection and add to cart. */
(function () {
  'use strict';

  var BARS = '.kaching-bundles__bars';
  var BAR  = '.kaching-bundles__bar';
  var FLAG = 'bundleScrollInit';

  // Bars shown on their own full-width row: listed deal-bar ids, plus any bar of different products.
  var FULL_ROW_IDS = '[data-deal-bar-id="stSt"]';
  var ROW_ATTR = 'data-ig-full-row';   // "source" on the hidden original, "clone" on the copy
  function isFullRow(bar) {
    return bar.matches(FULL_ROW_IDS) || !!bar.querySelector('.kaching-bundles__bundle-products');
  }

  // Real touch phones only — must match the CSS media query. A narrowed desktop
  // window reports pointer: fine and is therefore excluded.
  var MOBILE_MQ = '(max-width: 767px) and (pointer: coarse)';
  function isMobile() {
    return window.matchMedia && window.matchMedia(MOBILE_MQ).matches;
  }

  function chevron(dir) {
    var d = dir === 'left' ? 'M15 18l-6-6 6-6' : 'M9 6l6 6-6 6';
    return '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
           '<path d="' + d + '" stroke="currentColor" stroke-width="2" ' +
           'stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function arrow(dir, label) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ig-bundles-arrow ig-bundles-arrow--' + (dir === 'left' ? 'prev' : 'next');
    btn.setAttribute('aria-label', label);
    btn.innerHTML = chevron(dir);
    return btn;
  }

  function init(bars) {
    if (!bars || bars.dataset[FLAG]) return;
    bars.dataset[FLAG] = '1';

    try {
      bars.scrollLeft = 0;

      var wrapper = document.createElement('div');
      wrapper.className = 'ig-bundles-scroll-wrapper';
      bars.parentNode.insertBefore(wrapper, bars);
      wrapper.appendChild(bars);

      var prev = arrow('left', 'Forrige');
      var next = arrow('right', 'Næste');
      wrapper.appendChild(prev);
      wrapper.appendChild(next);

      var dotsWrap = document.createElement('div');
      dotsWrap.className = 'ig-bundles-dots';
      wrapper.parentNode.insertBefore(dotsWrap, wrapper.nextSibling);
      var dots = [];

      var row = document.createElement('div');
      row.className = 'kaching-bundles__bars ig-bundles-full-row ig-ready';
      dotsWrap.parentNode.insertBefore(row, dotsWrap.nextSibling);

      function step() {
        var card = bars.querySelector(BAR + ':not([' + ROW_ATTR + '])');
        if (!card) return bars.clientWidth * 0.8;
        var cs = window.getComputedStyle(bars);
        var gap = parseFloat(cs.columnGap || cs.gap || '0') || 0;
        return card.getBoundingClientRect().width + gap;
      }
      function maxScroll() { return bars.scrollWidth - bars.clientWidth; }

      function positionCount() {
        var s = step(), max = maxScroll();
        if (s <= 0 || max <= 1) return 1;
        return Math.round(max / s) + 1;
      }
      function activeIndex() {
        var s = step();
        if (s <= 0) return 0;
        var i = Math.round(bars.scrollLeft / s);
        return Math.max(0, Math.min(i, dots.length - 1));
      }

      function buildDots() {
        var count = positionCount();
        if (count === dots.length) return;
        dotsWrap.innerHTML = '';
        dots = [];
        if (count < 2) return;
        for (var i = 0; i < count; i++) {
          (function (idx) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'ig-bundles-dot';
            dot.setAttribute('aria-label', 'Gå til ' + (idx + 1));
            dot.addEventListener('click', function () {
              bars.scrollTo({ left: Math.min(idx * step(), maxScroll()), behavior: 'smooth' });
            });
            dotsWrap.appendChild(dot);
            dots.push(dot);
          })(i);
        }
      }

      function update() {
        var max = maxScroll(), x = bars.scrollLeft;
        prev.classList.toggle('ig-bundles-arrow--disabled', x <= 1);
        next.classList.toggle('ig-bundles-arrow--disabled', x >= max - 1);
        for (var i = 0; i < dots.length; i++) {
          dots[i].classList.toggle('ig-bundles-dot--active', i === activeIndex());
        }
      }

      function refresh() { buildDots(); update(); }

      // Tap the original's label, exactly like a shopper tapping the bar itself.
      function forward(src) {
        var target = src.querySelector('.kaching-bundles__bar-container') || src.querySelector('input') || src;
        target.click();
      }

      function fullRowClone(src) {
        var bar = src.cloneNode(true);
        bar.setAttribute(ROW_ATTR, 'clone');
        Array.prototype.forEach.call(bar.querySelectorAll('[id]'), function (el) { el.removeAttribute('id'); });
        Array.prototype.forEach.call(bar.querySelectorAll('label[for]'), function (el) { el.removeAttribute('for'); });
        Array.prototype.forEach.call(bar.querySelectorAll('input'), function (el) {
          el.removeAttribute('name');
          el.tabIndex = -1;
          el.setAttribute('aria-hidden', 'true');
        });
        bar.addEventListener('click', function (e) { e.preventDefault(); forward(src); });
        bar.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); forward(src); }
        });
        return bar;
      }

      // Rebuilds the row from the live bars, so price, text and selected state always match Kaching.
      var syncQueued = false;
      function syncFullRow() {
        syncQueued = false;
        var style = bars.getAttribute('style');   // Kaching's CSS variables live on the bars element
        if (style) row.setAttribute('style', style); else row.removeAttribute('style');
        var hadFocus = row.contains(document.activeElement);
        row.innerHTML = '';
        Array.prototype.forEach.call(bars.querySelectorAll(BAR), function (src) {
          if (!isFullRow(src)) return;
          if (src.getAttribute(ROW_ATTR) !== 'source') src.setAttribute(ROW_ATTR, 'source');
          row.appendChild(fullRowClone(src));
        });
        if (hadFocus) {
          var main = row.querySelector('[role="button"]');
          if (main) main.focus();
        }
        refresh();
      }
      function queueSync() {
        if (syncQueued) return;
        syncQueued = true;
        window.requestAnimationFrame(syncFullRow);
      }
      new MutationObserver(queueSync).observe(bars, { childList: true, subtree: true, attributes: true, characterData: true });

      prev.addEventListener('click', function () { bars.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { bars.scrollBy({ left: step(), behavior: 'smooth' }); });
      bars.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });

      var rt;
      window.addEventListener('resize', function () {
        clearTimeout(rt);
        rt = setTimeout(refresh, 150);
      });

      syncFullRow();
      // Re-measure once the app has finished painting its bars.
      setTimeout(function () { bars.scrollLeft = 0; refresh(); }, 300);
    } catch (e) {}

    bars.classList.add('ig-ready');
  }

  function boot() {
    if (!isMobile()) return;   // desktop (incl. shrunk window): leave Kaching's default layout untouched
    var bars = document.querySelector(BARS);
    if (bars) { init(bars); return; }
    var obs = new MutationObserver(function () {
      var el = document.querySelector(BARS);
      if (el) { obs.disconnect(); init(el); }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
